import Chip from '@mui/material/Chip';
import React from 'react';

const FeaturedTags = ({
  categories,
  handleFeaturedTags,
  navigate,
}: {
  categories: Categories;
  handleFeaturedTags: HandleFeaturedTags;
  navigate: Navigate;
}) => {
  const allTags = categories.flatMap((category) => category.tags);

  return (
    <div className="featured-tags">
      {allTags.map((tag) => {
        if (tag.featured) {
          return (
            <Chip
              classes={{
                root: 'tag',
                label: 'tag-label',
                icon: 'tag-icon',
              }}
              key={tag.name}
              label={tag.name}
              variant="outlined"
              icon={<img src={tag.icon} alt={tag.name} />}
              onClick={() => handleFeaturedTags(tag.name, navigate)}
            />
          );
        }
      })}
    </div>
  );
};

export default FeaturedTags;
